import React from 'react';

import { useLanguage } from '../LanguageContext';

export default function LcorParkingDetails() {
  const { t } = useLanguage();
  const tBlock = (k) => t(`schedule.lcor_parking.${k}`);

  const options = [
    {
      nameKey: 'opt1_name',
      walkKey: 'opt1_walk',
      rateKey: 'opt1_rate',
      badge: 'nearest',
      addressKey: 'opt1_address',
    },
    {
      nameKey: 'opt2_name',
      walkKey: 'opt2_walk',
      rateKey: 'opt2_rate',
      addressKey: 'opt2_address',
    },
    {
      nameKey: 'opt3_name',
      walkKey: 'opt3_walk',
      rateKey: 'opt3_rate',
      addressKey: 'opt3_address',
    },
    {
      nameKey: 'opt4_name',
      walkKey: 'opt4_walk',
      rateKey: 'opt4_rate',
      addressKey: 'opt4_address',
    },
  ];

  return (
    <div className="w-full my-4 space-y-3">
      <p className="text-content-c1 text-lg">
        {tBlock('parking_note1')}
      </p>
      <p className="text-content-c1 text-lg">
        {tBlock('parking_note2')}
      </p>
      {/* Table */}
      <div className="rounded-xl border border-divider shadow-sm bg-white/70 backdrop-blur-sm overflow-x-auto">
        <table className="w-full text-left border-collapse">
          <thead>
            <tr className="bg-blush-bg/80 border-b border-divider text-content-c1-sb text-lg uppercase tracking-wider">
              <th scope="col" className="py-3 px-4">
                {tBlock('headers.location')}
              </th>
              <th scope="col" className="py-3 px-4">
                {tBlock('headers.walk')}
              </th>
              <th scope="col" className="py-3 px-4">
                {tBlock('headers.rates')}
              </th>
            </tr>
          </thead>
          <tbody className="divide-y divide-divider/50">
            {options.map((opt, idx) => (
              <tr
                key={idx}
                className={`transition-colors hover:bg-offwhite-bg/80 ${
                  opt.badge === 'nearest' ? 'bg-blush-bg/30 font-medium' : ''
                }`}
              >
                <td className="py-3.5 px-4 align-top">
                  <div className="flex flex-col gap-1">
                    <div className="flex items-center gap-2 flex-wrap">
                      <span className="text-content-c1-sb text-base">
                        {tBlock(opt.nameKey)}
                      </span>
                      <span className="text-content-c1 text-base">
                        {tBlock(opt.addressKey)}
                      </span>
                      {opt.badge === 'nearest' && (
                        <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-content-c1 bg-rose-accent/15 border border-rose-accent/30 text-sm">
                          ★ {tBlock('badges.nearest')}
                        </span>
                      )}
                    </div>
                  </div>
                </td>
                <td className="py-3.5 px-4 align-top text-content-c1">
                  <div className="flex items-center gap-1.5 text-base">
                    <span>📍</span>
                    <span>{tBlock(opt.walkKey)}</span>
                  </div>
                </td>
                <td className="py-3.5 px-4 align-top text-content-c1">
                  <div className="flex items-center gap-1.5 text-base">
                    <span>💰</span>
                    <span>{tBlock(opt.rateKey)}</span>
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {/* Arrival Note */}
      <div className="text-content-c1 flex items-start gap-2.5 pt-2">
        <span className="text-lg leading-none">⏳</span>
        <p className="flex-1 font-medium text-lg text-content-c1">
          {tBlock('arrival_note')}
        </p>
      </div>

      {/* Disclaimer */}
      <p className="text-base text-content-c1 italic pt-1">
        *{tBlock('disclaimer')}
      </p>
    </div>
  );
}
